import type { SuggestionOption } from '~/components/core/Editor/types';
import type { SuggestionToken } from '~/components/SystemConfiguration/SystenConfigurationTypes';
import useDataFetcher from '~/components/useDataFetcher';

export interface TemplateTokensResponse {
  tokens: SuggestionToken[];
}

export const EMAIL_CONFIGURATION_TOKENS = {
  emailTitleTokens: ['CLAIM_ID_DISPLAY', 'SUB_ORGANIZATION_NAME', 'ORGANIZATION_NAME'],
  claimEmailAddressToken: ['CLAIM_EMAIL_OR_USER_EMAIL_FALLBACK'],
  emailSignatureTokens: [
    'USER_FULL_NAME',
    'USER_TITLE',
    'CLAIM_CURRENT_USER_LOSS_STATE_LICENSE_NUMBER',
    'API_CLAIM_INCIDENT_DETAILS_LOSS_LOCATION_STATE',
    'USER_EMAIL',
    'USER_PHONE_NUMBER',
    'SUB_ORGANIZATION_NAME',
    'ORGANIZATION_NAME',
  ],
};

export const noSubOrgEmailTitleTokens = EMAIL_CONFIGURATION_TOKENS.emailTitleTokens.filter(
  (token: string) => token !== 'SUB_ORGANIZATION_NAME'
);

export const noSubOrgEmailSignatureTokens = EMAIL_CONFIGURATION_TOKENS.emailSignatureTokens.filter(
  (token: string) => token !== 'SUB_ORGANIZATION_NAME'
);

export const useTokensFetcher = (organizationId: string | number, tokensSubset: string[]) => {
  return useDataFetcher<TemplateTokensResponse>(
    `/api/v1/generic_templates/organization/${organizationId}/template/tokens?`,
    {
      params: {
        tokens_subset: tokensSubset,
        feature_specific: 'email_configuration',
      },
    }
  );
};

export const mapTokensToSuggestionOptions = (tokensData: TemplateTokensResponse | undefined): SuggestionOption[] =>
  tokensData?.tokens?.map((token: SuggestionToken) => ({
    label: token.display_name,
    id: token.token_key,
  })) || [];
